import './YelpHelp.css';

function YelpHelp(currentActor) {
  return(
    <div className="yelp-help-container">
     <div className="yelp-help-title">
      My senior Project: Yelp Help (Demo)
     </div>
     <iframe src="https://www.youtube.com/embed/0Kl7PAINJ2M" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  )
}

export default YelpHelp;
